import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import withBackSupport from 'components/HOCs/withBackSupport';
import withMenu from 'components/HOCs/withMenu';
import useLeaveFor from 'hooks/useLeaveFor';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import {
  fetchContinueWatching,
  loadExtraContinueWatchingItems,
  resetAllContinueWatchingData,
  removeItem,
} from 'actions/continue-watching';
import { selectContinueWatching } from 'reducers/continue-watching/selectors';
import { navigateToPlayerPage } from 'actions/player';
import withScrollHack from 'components/HOCs/withScrollHack';
import NotLoggedStub from './NotLoggedStub';
import ContinueWatchingPage from './Page';

const ContinueWatchingContainer = (props) => {
  const { isLoggedIn, resetAllContinueWatchingData, ...rest } = props;
  const history = useHistory();

  useLeaveFor(history, (location) => {
    // It clears all data, because all data could be changed outside player
    if (!location.pathname.startsWith('/player')) {
      resetAllContinueWatchingData();
    }
  });

  if (!isLoggedIn) return <NotLoggedStub />;

  return <ContinueWatchingPage {...rest} />;
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
  items: selectContinueWatching,
});

export const mapDispatchToProps = {
  fetchContinueWatching,
  loadExtraContinueWatchingItems,
  resetAllContinueWatchingData,
  removeItem,
  navigateToPlayerPage,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withBackSupport,
  withMenu,
  withScrollHack,
)(ContinueWatchingContainer);
